import { ILink } from 'constants/links'

export const ALWAYS_VISIBLE_ABRS = [
  '*',
  'operationGroups',
  'tasks',
  'configurations',
  'ops',
  'organogram',
]

export const normalizePath = (path: string) => (path.startsWith('/') ? path : '/' + path)

export const isPathActive = (target: string, pathname: string) => {
  const normalized = normalizePath(target)
  return pathname === normalized || pathname.startsWith(normalized + '/')
}

export const isModuleActive = (module: ILink, pathname: string) => {
  if (isPathActive(module.path, pathname)) {
    return true
  }
  return (module.list ?? []).some((sub) => isPathActive(sub.path, pathname))
}

export const filterLinksByPermission = (
  links: ILink[],
  permissionPolicy?: { [key: string]: boolean },
) =>
  links.filter(
    (link) =>
      !link.abr ||
      ALWAYS_VISIBLE_ABRS.includes(link.abr) ||
      Boolean(permissionPolicy && permissionPolicy[link.abr]),
  )
